import { render, staticRenderFns } from "./groupSelect.vue?vue&type=template&id=3b2bf568&scoped=true"
import script from "./groupSelect.vue?vue&type=script&lang=js"
export * from "./groupSelect.vue?vue&type=script&lang=js"
import style0 from "./groupSelect.vue?vue&type=style&index=0&id=3b2bf568&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2bf568",
  null
  
)

export default component.exports